import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigResponse } from '../models/config-response.model';
import { SponsorResponse } from '../models/sponsor-response.model';
import { SponsorshipResponse } from '../models/sponsorship-response.model';
import { SubscriptionPayload } from '../models/subscription-payload.model';

@Injectable({ providedIn: 'root' })
export class SponsorshipService {
  public http = inject(HttpClient);

  public getConfig(): Observable<ConfigResponse> {
    return this.http.get<ConfigResponse>(
      `/apps/ia-parrainage-filleul/config/ia-parrainage-filleul-conf-V1.json`,
    );
  }

  public fetchSponsorship(code: string): Observable<SponsorshipResponse> {
    return this.http.get<SponsorshipResponse>(`/rgg/myami-nc/v1/advantages/${code}`);
  }

  public fetchSponsor(token: string): Observable<SponsorResponse> {
    return this.http.get<SponsorResponse>(`/rgg/myami-nc/v1/referrals/${token}`);
  }

  public postSubscription(subscription: SubscriptionPayload): Observable<HttpResponse<string>> {
    return this.http.post(`/rgg/myami-nc/v1/referees`, subscription, {
      observe: 'response',
      responseType: 'text',
    });
  }
}
